import React, { useCallback, useState, useMemo } from 'react';
import { StatisticsGrid, IStatisticsGrid, IStatistic } from "@sky-it-livedata/livedata-sports-design-system";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { PlayerStatisticsQuery } from "./types";

import transformQuery from "./transformers/query";
import { isEmptyObject } from '../../utils/tests';

const isStatistic = (item: unknown): item is IStatistic => {
  return Boolean(
    item &&
      typeof item === 'object' &&
      'id' in item &&
      'value' in item
  );
};


export const setCustomAttributes = ({
  variables,
}: WidgetContext<PlayerStatisticsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};


export const getServerProps = ({
  props
}: WidgetContext<PlayerStatisticsQuery>): IStatisticsGrid => {
  return transformQuery(props);
}

const PpPlayerStatisticsWidget = ({
  props,
  ...rest
}: WidgetContext<IStatisticsGrid>) => {
  log({ props, ...rest });

  const [dropdownIndex, setDropdownIndex] = useState(0);
  
  const onDropDownChange = useCallback(
    (dropdownIndex: number) => {
      setDropdownIndex(dropdownIndex);
    },
    [setDropdownIndex]
  );

   const componentMapped: IStatisticsGrid | undefined | null = useMemo(() => {

    if (!isEmptyObject(props)) {
      const selectedItems = props.statisticsMap?.find((_, index: number) => index === dropdownIndex)?.items ?? [];

      const statistics = 'playerId' in props.statistics
        ? {
            ...props.statistics,
            items: selectedItems,
          }
        : {
            ...props.statistics,
            items: selectedItems.filter(isStatistic),
          };

      return {
        ...props,
        dropdown: {
          ...(props.dropdown ?? {}),
          text: props.dropdown?.text ?? '',
          links: ((props?.dropdown?.links ?? []).map((link, index) =>
            index === dropdownIndex ? { ...link, isSelected: true } : { ...link, isSelected: false }
          )),
          onClick: (_: React.MouseEvent, id: number) => onDropDownChange(id),
        },
        statistics,
      };
    }

    return null;

   }, [props, dropdownIndex, onDropDownChange]);

  return componentMapped && !isEmptyObject(componentMapped) ? (
    <div>{<StatisticsGrid {...componentMapped} />}</div>
  ) : null;
}

export default PpPlayerStatisticsWidget;